import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Markets from "@/pages/Markets";
import Stocks from "@/pages/Stocks";
import News from "@/pages/News";
import NFTs from "@/pages/NFTs";
import Crypto from "@/pages/Crypto";
import AssetDetail from "@/pages/AssetDetail";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id - intercept before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/markets" element={<Markets />} />
        <Route path="/stocks" element={<Stocks />} />
        <Route path="/news" element={<News />} />
        <Route path="/nfts" element={<NFTs />} />
        <Route path="/crypto" element={<Crypto />} />
        <Route path="/asset/:type/:id" element={<AssetDetail />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
